import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    width: '100%',
    marginTop: UNIT
  },

  paper: { overflowX: 'auto', backgroundColor: mainColor.colorMediumGray, width: '100%' },
  content: { backgroundColor: 'rgba(200, 200, 200, 0.3)' },
  label: {
    fontSize: UNIT * 0.75,
    display: 'inline-block',
    width: '100%',
    color: mainColor.colorBlack
  },
  labelText: {
    color: mainColor.colorClearGray,
    padding: 5,
    fontSize: UNIT * 0.75
  },
  rightText: {
    color: mainColor.colorClearGray,
    padding: 5,
    fontSize: UNIT * 0.75,
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  valueStyle: { fontWeight: 'bolder', margin: 0, textAlign: 'left' },
  title: {
    fontSize: UNIT * 0.875,
    color: mainColor.colorBlackLight,
    fontWeight: 'bolder'
  },
  fab: {
    backgroundColor: `rgba(${mainColor.rgb}, 0.8)`,
    '&:hover': {
      backgroundColor: `rgba(${mainColor.rgb}, 1)`
    }
  },
  pos: {
    display: 'inline-block',
    fontSize: UNIT * 0.75,
    color: 'grey'
  },
  icon: {
    fontSize: UNIT * 1.5,
    color: mainColor.colorBlack,
    align: 'center'
  },
  heading: {
    flexShrink: 0,
    flexBasis: '21%',
    textAlign: 'center',

    fontSize: UNIT * 0.75,
    alignSelf: 'center'
  },
  dayLabel: {
    fontSize: UNIT * 0.75,
    display: 'inline-block',
    textAlign: 'left',
    paddingLeft: UNIT * 0.625,
    flexBasis: '33%',
    color: mainColor.colorBlack
  },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '5px'
  },
  itemStyle: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  table: {
    backgroundColor: mainColor.colorWhite
  },
  post: { display: 'inline-block', width: '70%' },
  slotStyle: { marginLeft: 'auto', marginRight: UNIT * 0.625 },
  listStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center !important',
    padding: '7px 7px 0px 7px'
  },
  listItemStyle: { width: '100%', marginLeft: -UNIT, textAlign: 'left' },
  variationSize: { flexBasis: '20%', maxWidth: '20%' },
  paperStyle: {
    cursor: 'pointer',
    margin: '10px 0px',
    padding: UNIT * 0.625
  },
  methodTypeStyle: {
    cursor: 'pointer',
    backgroundColor: 'transparent'
  },
  card: {
    marginTop: UNIT * 0.625,
    padding: UNIT * 0.625,
    borderColor: mainColor.colorGray,
    borderRadius: UNIT,
    backgroundColor: 'white',
    border: '1px solid '
  },
  row: {
    minWidth: UNIT * 15,
    maxWidth: UNIT * 15,
    padding: UNIT * 0.625,
    verticalAlign: 'top'
  },
  textStyle: {
    fontSize: UNIT * 0.875,
    fontWeight: 'bolder',
    paddingRight: UNIT * 1.25
  },
  lastTitle: {
    display: 'flex',
    fontSize: UNIT * 0.875,
    color: mainColor.colorBlackLight,
    justifyContent: 'center',
    paddingTop: UNIT * 0.625,
    paddingBottom: UNIT * 0.625,
    alignItems: 'center',
    fontWeight: 'bolder'
  },
  labelStyle: {
    fontSize: UNIT * 0.75,
    color: mainColor.colorBlack,
    flexDirection: 'row',
    fontWeight: 'bolder',

    display: 'inline-block',
    width: '30%'
  },

  typoDetails: {
    fontSize: UNIT * 0.75,
    display: 'inline-block',
    width: '100%',
    color: mainColor.colorBlack
  },
  hrStyle: {
    border: '0',
    height: '1px',
    backgroundImage:
      'linear-gradient(to right, rgba(200, 200, 200, 0.5), rgba(200, 200, 200, 0.75), rgba(200, 200, 200, 0.5))'
  },
  subtitle: {
    fontWeight: 'bolder'
  },
  textStyling: { fontSize: UNIT * 0.75, textAlign: 'center', padding: 0.3125 },
  body: { margin: '10px 5px', textAlign: 'center' },
  progress: {
    margin: UNIT * 6,
    color: mainColor.secondaryColor
  }
});
